// extracted by mini-css-extract-plugin
module.exports = {"departments":"nf","departmentHeading":"of","departmentSection":"pf","departmentName":"qf","departmentLink":"rf","expandIcon":"sf"};